import { render, staticRenderFns } from "./CommuneGroupItem.vue?vue&type=template&id=4c30ecec&scoped=true"
import script from "./CommuneGroupItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommuneGroupItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommuneGroupItem.vue?vue&type=style&index=0&id=4c30ecec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c30ecec",
  null
  
)

export default component.exports